import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import DropdownActionButton from './dropdown-action-button';

import { claimDomains } from '../../../common/actions/domain-management-action-creators';
import { claimSuggestedDomains } from '../../../common/actions/suggested-domains-action-creators';
import { DOMAIN_HIERARCHY_SUBDOMAIN } from '../../../common/constants/definitions';

export class ClaimDomainAsButtonContainer extends Component{
    handleClaimDomains = ( domainType ) => {
        const { selectedDomains } = this.props;
        const domains = selectedDomains.map( domain => domain.domainName );

        this.updateDomains( domains, domainType );
    }

    updateDomains = ( domains, domainType ) => {
        const { selectedDomainFilter, type, claimDomains, claimSuggestedDomains } = this.props;

        // only discovered subdomains utilizes a different call
        if( type === 'discovered' && selectedDomainFilter === DOMAIN_HIERARCHY_SUBDOMAIN ){
            claimSuggestedDomains( domains, domainType );
        }
        else{
            claimDomains( domains, domainType );
        }
    }

    render(){
        return (
            <DropdownActionButton
                automationId="domain-management-claim-domain-as-button"
                handleSelectionChange={this.handleClaimDomains}
                type="domainType"
                text="Claim as"
            />
        );
    }
};

const mapDispatchToProps = {
    claimDomains,
    claimSuggestedDomains,
};

ClaimDomainAsButtonContainer.propTypes = {
    claimDomains: PropTypes.func.isRequired,
    claimSuggestedDomains: PropTypes.func.isRequired,
    selectedDomainFilter: PropTypes.string.isRequired,
    selectedDomains: PropTypes.array.isRequired,
    type: PropTypes.string.isRequired,
};

export default connect( null, mapDispatchToProps )( ClaimDomainAsButtonContainer );
